import { NotFound } from "~/components/not-found"
import { PeerHeader } from "~/components/peer-header"
import { PullToRefreshWrapper } from "~/components/pull-to-refresh-wrapper"
import { QueryBoundary, TitleQueryBoundary } from "~/components/query-boundary"
import PageLoading from "~/components/ui/page-loading"
import { Route } from "~/routes/topic.$id"
import { useTopicContent } from "../hooks/use-topic-content"
import { useTopic } from "../hooks/use-topic"
import { topicContentQueryKeys } from "../query-keys"
import { CalendarFeed } from "./calendar-feed"
import { DiscountsFeed } from "./discounts-feed"
import { MembersFeed } from "./members-feed"
import { PartnersFeed } from "./partners-feed"
import { PostsFeed } from "./posts-feed"

export function TopicPage() {
  const params = Route.useParams() as { id: string }
  const id = Number(params.id)

  return (
    <div className="flex-1 flex flex-col">
      <TitleQueryBoundary>
        <TopicHeader topicId={id} />
      </TitleQueryBoundary>
      <QueryBoundary loadingFallback={<PageLoading noHeader />}>
        <TopicContent topicId={id} />
      </QueryBoundary>
    </div>
  )
}

function TopicHeader({ topicId }: { topicId: number }) {
  const { data: topic } = useTopic(topicId)
  if (!topic) {
    return <NotFound title="Тема не найдена" message="Тема не существует или была удалена" />
  }

  return <PeerHeader name={topic.name} avatarUrl={topic.cover?.url} variant="group" titleLines={3} />
}

function TopicContent({ topicId }: { topicId: number }) {
  const { data: topic } = useTopic(topicId)
  const { data: content } = useTopicContent(topicId)

  if (!topic) {
    return <NotFound title="Тема не найдена" message="Тема не существует или была удалена" />
  }

  return (
    <PullToRefreshWrapper className="flex-1 flex flex-col" useWindowScroll queryKeyPrefix={topicContentQueryKeys(topicId)}>
      {content.kind === "partners" && <PartnersFeed partners={content.items} />}
      {content.kind === "members" && <MembersFeed members={content.items} />}
      {content.kind === "discounts" && <DiscountsFeed discounts={content.items} />}
      {content.kind === "calendar" && <CalendarFeed events={content.items} topicId={topicId} />}
      {content.kind === "posts" && (
        <PostsFeed
          topicId={topic.id}
          allowAdd={content.allowAdd}
          initialItems={content.items}
          initialNextPage={content.nextPage}
        />
      )}
    </PullToRefreshWrapper>
  )
}
